import type { ApiWire } from '../shared/types';

import type {
    DomainFeedConversionRate,
    DomainFeedConversionRateDay,
    FeedingConversionRateResult,
} from './types';

/** Normalises a raw metric, treating NaN and Infinity as absent. */
function toMetric(value: unknown): number | null {
    if (typeof value !== 'number' || !Number.isFinite(value)) {
        return null;
    }
    return value;
}

function mapFeedConversionRateDayToDomain(
    day: ApiWire<FeedingConversionRateResult['days'][number]>
): DomainFeedConversionRateDay {
    return {
        day: day.day,
        fcr: toMetric(day.fcr),
    };
}

/**
 * Maps the feed-conversion-rate response into the domain shape.
 *
 * Tolerates an absent response and an absent `days` array: the endpoint is
 * queried with a date range that can legitimately contain no feeding data, and
 * the legacy chart crashed on exactly that shape. An absent response reads as
 * "not refreshing" rather than leaving the poller believing one is in flight.
 */
export function mapFeedConversionRateToDomain(
    response: ApiWire<FeedingConversionRateResult> | null | undefined
): DomainFeedConversionRate {
    return {
        days: (response?.days ?? []).map(mapFeedConversionRateDayToDomain),
        refreshing: response?.refreshing ?? false,
        lastFetchedAt: response?.lastFetchedAt ? new Date(response.lastFetchedAt) : null,
    };
}
